import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import MoneyView from 'shared/components/MoneyView';
import { StockPropertiesFooterFragment } from './__generated__/StockPropertiesFooterFragment';
import { CurrentPrice } from './components/CurrentPrice';
import { Property } from './components/Property';
import { PriceDiff } from './components/PriceDiff';
import { Tariff } from './components/Tariff';

import './index.scss';

interface Props {
  stock: StockPropertiesFooterFragment;
}

const b = b_.with('stock-top-card-footer');

export const Footer: React.FC<Props> = ({ stock }) => {
  const { t } = useTranslation();

  return (
    <div className={b()}>
      <div className={b('row')}>
        <Property title={t('Change for the year')}>
          <PriceDiff>{stock.priceDiff}</PriceDiff>
        </Property>
        <Property title={t('Current price')}>
          <CurrentPrice stockId={stock.id} />
        </Property>
        <Property title={t('Capitalization')}>
          <MoneyView compactNotation>{stock.capitalization}</MoneyView>
        </Property>
      </div>
      <Tariff />
    </div>
  );
};
